<template>
  <div class="about">
    <h1>Page Not Found</h1>
    <p>Sorry, this page does not exist. Please use the navigation bar at the left to access content.</p>
    <!-- <p>Status of Account: {{ userStatus }}</p> -->
  </div>
</template>
<script>
export default {
  name: "PageNotFound",
  computed: {},
  data() {
    return {};
  }
};
</script>
